import { Order } from "../../../../merchant/controlKitchenTypes"
import { AxiosInstance } from "axios"

export enum UpcomingOrdersPurchases {
    UPCOMING_ORDERS_PURCHASES = "upcoming-orders-purchases",
}

export type FetchPurchasesResponse = Readonly<{
    orders: Order[] | null
}>

type FetchPurchasesParams = Readonly<{
    period?: string
    startDate?: string
    endDate?: string
}>

export async function fetchPurchasesByPeriod(
    params: FetchPurchasesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchPurchasesResponse> {
    const url = "/me/upcoming/pos"

    const response = await axios.get(url, {
        params,
        signal,
    })

    return response.data
}
